export function contentForResponse(response, preferredContentType = 'application/json') {
    if ((response === null || response === void 0 ? void 0 : response.content) === undefined) {
        return [preferredContentType, undefined];
    }
    const content = response.content[preferredContentType];
    if (content !== undefined) {
        return [preferredContentType, content];
    }
    const otherContentTypes = Object.keys(response.content);
    for (const contentType of otherContentTypes) {
        const content = response.content[contentType];
        if (content !== undefined) {
            return [contentType, content];
        }
    }
    return [preferredContentType, undefined];
}
